// src/components/appointments/components/AppointmentStatusBadge.jsx
export const AppointmentStatusBadge = ({ status }) => {
    const statusConfig = {
      scheduled: {
        className: 'bg-blue-100 text-blue-800',
        label: 'Scheduled'
      },
      completed: {
        className: 'bg-green-100 text-green-800',
        label: 'Completed'
      },
      cancelled: {
        className: 'bg-red-100 text-red-800',
        label: 'Cancelled'
      },
      'no-show': {
        className: 'bg-yellow-100 text-yellow-800',
        label: 'No Show'
      }
    };
  
    const config = statusConfig[status] || statusConfig.scheduled;
  
    return (
      <span className={`px-2 py-1 text-xs rounded-full font-medium ${config.className}`}>
        {config.label}
      </span>
    );
  };